// extracted by mini-css-extract-plugin
module.exports = {"container":"da51a739f7--container--WxZey","title":"da51a739f7--title--T_9Kq","list":"da51a739f7--list--IU3yG","item":"da51a739f7--item--Dy0lD"};